import React, { useEffect, useState } from "react";
import { Outlet, useLocation } from "react-router-dom";

import AccountSidebar from "./AccountSidebar";
import Navbar from "../Navbar";
import Footer from "../Footer";

export default function AccountLayout() {
  const location = useLocation();

  const isCompactPage =
    location.pathname === "/account/profile" ||
    location.pathname.endsWith("/profile") ||
    location.pathname === "/account/help" ||
    location.pathname.endsWith("/help") ||
    location.pathname === "/account/address" ||
    location.pathname.endsWith("/address");

  const [sidebarOpen, setSidebarOpen] = useState(() => {
    const saved = localStorage.getItem("accountSidebarOpen");

    if (saved !== null) {
      return JSON.parse(saved);
    }

    return window.innerWidth >= 1024;
  });

  useEffect(() => {
    localStorage.setItem("accountSidebarOpen", JSON.stringify(sidebarOpen));
  }, [sidebarOpen]);

  return (
    <div className="flex min-h-screen flex-col">
      {/* NAVBAR */}
      <Navbar onMenuClick={() => setSidebarOpen((prev) => !prev)} />

      {/* ACCOUNT CONTENT */}
      <div className="flex-1 bg-blue-50">
        <div
          className={`
            mx-auto
            flex
            w-full
            max-w-7xl
            px-4

            md:gap-6

            ${isCompactPage ? "py-4 sm:py-5" : "py-5 sm:py-6"}
          `}
        >
          {/* DESKTOP SIDEBAR - REAL DESKTOP ONLY */}
          <div
            className="
              hidden
              w-[250px]
              shrink-0

              lg:block

              [@media(pointer:coarse)]:hidden
            "
          >
            <AccountSidebar
              sidebarOpen={sidebarOpen}
              setSidebarOpen={setSidebarOpen}
            />
          </div>

          {/* MOBILE / TOUCH SIDEBAR */}
          <div
            className="
              lg:hidden

              [@media(pointer:coarse)]:block
            "
          >
            <AccountSidebar
              sidebarOpen={sidebarOpen}
              setSidebarOpen={setSidebarOpen}
            />
          </div>

          {/* PAGE CONTENT */}
          <div className="min-w-0 flex-1">
            <Outlet />
          </div>
        </div>
      </div>

      {/* FOOTER */}
      <Footer />
    </div>
  );
}
